<template>
  <div id="member">
    <div class="page-header header-filter" data-parallax="true" style="background-image: url('static/img/member.jpg'); height:50vh; background-position:0px 27%">
      <div class="container">
          <div class="row">
            <div class="col-md-8 ml-auto mr-auto">
                <div class="brand text-center">
                  <h1 class="title" id="hide_edit" @click="edit_member">中心主要成員</h1>
                  <h3 class="title description">Key Personnel</h3>
                </div>
            </div>
          </div>
      </div>
    </div>
    <div class="main main-raised">
        <div class="container">
          <div class="section text-center">
            <!--     *********    TEAM 1     *********      -->
            <!--     *********    MORPHING CARDS     *********      -->
            <div class="cards" id="morphingCards">
              <div class="container">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                      <!-- <h2 class="title">Teachers</h2> -->
                      <!-- <h5 class="description">Key Personnel</h5> -->
                    </div>
                </div>
                <div class="row">
                  <template v-for="(item, index) in professor">
                      <div class="col-md-8 col-lg-4 mt-3" :key="index">
                        <div class="rotating-card-container">
                          <div class="card card-rotate card-profile card-background">
                            <div class="front">
                                  <!-- 圓形 預設 130*130-->
                                  <div class="card-header card-avatar" style="width:200px; max-width:200px; max-height:200px">
                                  <!-- <div class="card-header card-header-image" style="width:300px; max-width:300px; max-height:450px"> -->
                                    <div>
                                      <!-- <img class="img" :src="item.pic | imgUrl"> -->
                                      <img v-if="item.img == 'placeholder'" src="static/img/placeholder.jpg" />
                                      <img v-else :src="item.img" />
                                    </div>
                                  </div>
                                  <div class="card-body" style="height:250px">
                                    <!-- <h4 class="title">{{ item.name }}</h4>
                                    <h5 class="category text-muted">{{ item.position.split(';')[0] }}</h5>
                                    <h6 class="category text-muted">{{ item.position.split(';')[1] }}</h6> -->
                                    <h4 class="title">{{ item.name_cht }}
                                      <h6 class="category text-muted">{{ item.name_eng }}</h6>
                                    </h4>
                                    <h5 class="category text-muted">{{ item.job_title_cht }}</h5>
                                    
                                    <template v-for="(item_jt, index_jt) in item.job_title_eng.split(';').length">
                                      {{ item.job_title_eng.split(';')[index_jt] }}<br :key="index_jt">
                                    </template>
                                    
                                    <div class="text-muted mt-2">{{ item.email }}</div>
                                    
                                  </div>
                            </div>
                            <div class="back back-background" style="background-image: url('./static/img/examples/blog3.jpg');">
                              <div class="card-body">
                                <template v-for="(item_e, index_e) in item.profession_cht.split(';').length">

                                  <p class="card-description h4" :key="index_e">      
                                    {{ item.profession_cht.split(';')[index_e] }} <br>
                                    {{ item.profession_eng.split(';')[index_e] }} <br>
                                  </p>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                  </template>
                </div>
              </div>
            </div>
            <!--     *********    END MORPHING CARDS      *********      -->
            <!--     *********    END TEAM 1      *********      -->
            <!--     *********    TEAM 2     *********      -->
            <div class="cd-section" id="teams2">
              <div class="team-2" id="team-2">
                <div class="container">
                  <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                      <h2 class="title">顧問</h2>
                      <h5 class="description">Consultant</h5>
                    </div>
                  </div>
                  <div class="row">
                    <template v-for="item in consultant">
                      <div class="col-md-4" :key="item.id">
                        <!-- <div class="card card-profile card-plain"> -->
                        <div class="card card-profile">
                          <!-- 橫矩形 -->
                          <!-- <div class="card-header card-header-image"> -->
                          <!-- 圓形 預設 130*130-->
                          <div class="card-header card-avatar" style="width:150px; max-width:150px; max-height:150px">
                              <!-- <img :src="item.pic | imgUrl"> -->
                              <img v-if="item.img == 'placeholder'" src="static/img/placeholder.jpg" />
                              <img v-else :src="item.img" />
                          </div>
                          <div class="card-body ">
                            <h4 class="card-title">{{ item.name_cht }}</h4>
                            <h6 class="card-category text-muted">{{ item.name_eng }}</h6>
                            <div class="text-muted mt-2">{{ item.email }}</div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <!--     *********    END TEAM 2      *********      -->
            <!--     *********    TEAM 3     *********      -->
            <div class="cd-section" id="teams3">
              <div class="team-2" id="team-3">
                <div class="container">
                  <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                      <h2 class="title">博士後研究員</h2>
                      <h5 class="description">Postdoctoral Researcher</h5>
                    </div>
                  </div>
                  <div class="row">
                    <template v-for="item in postdoctoral">
                      <div class="col-md-4" :key="item.id">
                        <!-- <div class="card card-profile card-plain"> -->
                        <div class="card card-profile">
                          <!-- 橫矩形 -->
                          <!-- <div class="card-header card-header-image"> -->
                          <!-- 圓形 預設 130*130-->
                          <div class="card-header card-avatar" style="width:150px; max-width:150px; max-height:150px">
                              <!-- <img :src="item.pic | imgUrl"> -->
                              <img v-if="item.img == 'placeholder'" src="static/img/placeholder.jpg" />
                              <img v-else :src="item.img" />
                          </div>
                          <div class="card-body ">
                            <h4 class="card-title">{{ item.name_cht }}</h4>
                            <h6 class="card-category text-muted">{{ item.name_eng }}</h6>
                            <div class="text-muted mt-2">{{ item.email }}</div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <!--     *********    END TEAM 3      *********      -->
            <!--     *********    TEAM 4     *********      -->
            <div class="cd-section" id="teams4">
              <div class="team-2" id="team-4">
                <div class="container">
                  <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                      <h2 class="title">專任研究員</h2>
                      <h5 class="description">Researcher</h5>
                    </div>
                  </div>
                  <div class="row">
                    <template v-for="item in researcher">
                      <div class="col-md-4" :key="item.id">
                        <div class="card card-profile">
                          <div class="card-header card-avatar" style="width:150px; max-width:150px; max-height:150px">
                              <!-- <img :src="item.pic | imgUrl"> -->
                              <img v-if="item.img == 'placeholder'" src="static/img/placeholder.jpg" />
                              <img v-else :src="item.img" />
                          </div>
                          <div class="card-body ">
                            <h4 class="card-title">{{ item.name_cht }}</h4>
                            <h6 class="card-category text-muted">{{ item.name_eng }}</h6>
                            <div class="text-muted mt-2">{{ item.email }}</div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <!--     *********    END TEAM 4      *********      -->
            <!--     *********    TEAM 5     *********      -->
            <div class="cd-section" id="teams5">
              <div class="team-2" id="team-5">
                <div class="container">
                  <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                      <h2 class="title">專任研究助理</h2>
                      <h5 class="description">Assistant</h5>
                    </div>
                  </div>
                  <div class="row">
                    <template v-for="item in assistant">
                      <div class="col-md-4" :key="item.id">
                        <div class="card card-profile">
                          <div class="card-header card-avatar" style="width:150px; max-width:150px; max-height:150px">
                              <!-- <img :src="item.pic | imgUrl"> -->
                              <!-- <img class="img" src="/static/img/faces/card-profile1-square.jpg"> -->
                              <img v-if="item.img == 'placeholder'" src="static/img/placeholder.jpg" />
                              <img v-else :src="item.img" />
                          </div>
                          <div class="card-body ">
                            <h4 class="card-title">{{ item.name_cht }}</h4>
                            <h6 class="card-category text-muted">{{ item.name_eng }}</h6>
                            <div class="text-muted mt-2">{{ item.email }}</div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <!--     *********    END TEAM 5      *********      -->
            <!--     *********    TEAM 6     *********      -->
            <div class="cd-section" id="teams5">
              <div class="team-2" id="team-5">
                <div class="container">
                  <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                      <h2 class="title">博士級研究生</h2>
                      <h5 class="description">Ph. D.</h5>
                    </div>
                  </div>
                  <div class="row">
                    <template v-for="item in ph_d">
                      <div class="col-md-4" :key="item.id">
                        <div class="card card-profile">
                          <div class="card-header card-avatar" style="width:150px; max-width:150px; max-height:150px">
                              <!-- <img :src="item.pic | imgUrl"> -->
                              <!-- <img class="img" src="/static/img/faces/card-profile1-square.jpg"> -->
                              <img v-if="item.img == 'placeholder'" src="static/img/placeholder.jpg" />
                              <img v-else :src="item.img" />
                          </div>
                          <div class="card-body ">
                            <h4 class="card-title">{{ item.name_cht }}</h4>
                            <h6 class="card-category text-muted">{{ item.name_eng }}</h6>
                            <div class="text-muted mt-2">{{ item.email }}</div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <!--     *********    END TEAM 6      *********      -->
          </div>
        </div>
    </div>
    
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "member",
  props: [],
  data() {
    return {
      professor: [],
      postdoctoral:[],
      researcher: [],
      assistant: [],
      consultant: [],
      ph_d: [],
    };
  },
  methods: {
    getprofessorInfo: function(){
      var vm = this;
      // console.log('getprofessorInfo')
       axios
          .get(`/api/getprofessorInfo`)
          .then(res => {
            // console.log(res.data);
            var professor = res.data.data.sort(function (a, b) {
              return a.id > b.id ? 1 : -1;
              });
            vm.professor = professor;
          })
          .catch(err => {
            console.log(err);
          });
    },
    getmembersInfo: function(){
      var vm = this;
      // console.log('getmembersInfo')
       axios
          .get(`/api/getmembersInfo`)
          .then(res => {
            // console.log(res.data);
            var data = res.data.data;
            data = data.sort(function (a, b) {
              return a.id > b.id ? 1 : -1;
              });

            data.forEach(function(item) {
              if(item.job_title_cht == "博士後研究員"){
                vm.postdoctoral.push(item);
              }
              if (item.job_title_cht =="專任研究員"){
                  vm.researcher.push(item);
              }
              if (item.job_title_cht =="專任研究助理"){
                  vm.assistant.push(item);
              }
              if (item.job_title_cht =="顧問"){
                  vm.consultant.push(item);
              }
              if (item.job_title_cht =="博士級研究生"){
                  vm.ph_d.push(item);
              }
          });
            
          })
          .catch(err => {
            console.log(err);
          });
    },
    edit_member: function(){
      var vm = this;
      document.querySelector('#hide_edit').addEventListener('click', function (evt) {
          // console.log(evt.detail)

          if(evt.detail === 3){
              vm.$router.push("/about/edit_member").catch(error => {
                  if (error.name != "NavigationDuplicated") {
                      throw error;
                  }
              });
          }
      });
    },
  },
  filters: {
    imgUrl: function(value) {
      if(value != null || value != 'null' || value != ''){
        value = "/static/img/members/" + value + ".jpg";
      }
      else{
        value = "/static/img/members/placeholder.jpg";
      }
      
      return value;
    }
  },
  computed: {},
  created() {
    this.getprofessorInfo();
    this.getmembersInfo();
  },
  mounted() {
  },
  components: {},
  watch: {}
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/about/member.vue